<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="申请时间:">
                <custom-date-range
                  :start-date="searchForm.applyTimeStart"
                  :end-date="searchForm.applyTimeEnd"
                  @update:startDate="(val) => (searchForm.applyTimeStart = val)"
                  @update:endDate="(val) => (searchForm.applyTimeEnd = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主归属:" prop="companyId">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.companyId"
                  filterable
                  allow-create
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in agentData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="货主名称:" prop="ownerName">
                <el-input
                  v-model="searchForm.ownerName"
                  clearable
                  autocomplete="off"
                  maxlength="30"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="手机号码:" prop="phone">
                <el-input v-model="searchForm.phone" clearable autocomplete="off" maxlength="30" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="处理状态:" prop="invoiceStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.invoiceStatus"
                  filterable
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.handleTypeOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="custom-tip">
        <span>共{{ tableOptions.total }}项</span>
        <span class="price-label">开票金额：</span>
        <span class="price color52C41A">￥{{ numberToThousand(overviewData) }}</span>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:amount="{ row }">￥{{ row.amount }}</template>
        <template v-slot:invoiceStatus="{ row }">
          <span class="common-status status-pending-order" v-if="row.invoiceStatus === 0">待处理</span>
          <span class="common-status status-confirm" v-if="row.invoiceStatus === 1">已处理</span>
        </template>
        <template v-slot:operation="{ row }">
          <span
            class="operate-btn"
            :class="row.invoiceStatus === 1?'operate-btn-disabled':''"
            @click="row.invoiceStatus === 1?'':handleGenDan(row)">
            处理
          </span>
          <span class="operate-btn" @click="openDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import {numberToThousand} from "@/utils/tool"
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getPage, getOwnerOverview } from "./api";
import tableMixin from "@/mixin/tableMixin";

import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        applyTimeEnd: "",
        applyTimeStart: "",
        companyId: "",
        invoiceStatus: "",
        ownerName: "",
        phone: "",
      },
      haveCompany: true,
      overviewData: "",
      isImmediatelyGetData: true,
      haveBelongCompany: false,
      agentData: [],
      tableColumn: [
        {
          label: "申请时间",
          prop: "applyTime",
          align: "left",
          show: true,
        },
        {
          label: "货主归属",
          prop: "companyName",
          align: "left",
          show: true,
        },
        {
          label: "货主名称",
          prop: "ownerName",
          align: "left",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "开票金额",
          prop: "amount",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "处理状态",
          prop: "invoiceStatus",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
    this.getSelectCompany()
    this.getAllData();
  },
  mounted() {},
  methods: {
    numberToThousand,
    getSelectCompany() {
      getSelectAgent({keyword:"",belongCompanyId: ""}).then((res) => {
        if (res.code === 200) {
          this.agentData = res.data;
        }
      });
    },
    handleCheck() {
      this.getAllData();
      this.getTableData();
    },
    handleOtherThing() {
      this.getAllData();
    },
    getAllData() {
      getOwnerOverview({
        applyTimeEnd: this.searchForm.applyTimeEnd,
        applyTimeStart: this.searchForm.applyTimeStart,
        companyId: this.searchForm.companyId,
        invoiceStatus: this.searchForm.invoiceStatus,
        ownerName: this.searchForm.ownerName,
        phone: this.searchForm.phone,
      }).then((res) => {
        if (res.code === 200) {
          this.overviewData = res.data.amount;
        }
      });
    },
    handleGenDan(row) {
      this.$refs.addOrEdit.init("开票处理", false, row);
    },
    openDetail(row) {
      this.$refs.addOrEdit.init("开票处理详情", true, row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    .price-label {
      padding: 0 0.04rem 0 0.1rem;
    }
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
